import React, {useCallback, useState, type JSX} from 'react';
import {Box} from '@mui/material';

type Props = {
  videoId: string;
  testId?: string;
};

const DOMAIN = 'https://player.vimeo.com/video/';

const videoStyles = {
  position: 'absolute',
  left: 0,
  top: 0,
  width: '100%',
  height: '100%',
  overflow: 'hidden',
  borderRadius: '16px',
  border: 'none',
};

function VimeoVideoPlayer({testId, videoId}: Readonly<Props>): JSX.Element {
  const [isFirstPlay, setIsFirstPlay] = useState<boolean>(true);

  const onPlayFist = useCallback(async () => {
    setIsFirstPlay(previousState => !previousState);
  }, []);

  const src = isFirstPlay
    ? `${DOMAIN}${videoId}?controls=0&autoplay=0&responsive=1`
    : `${DOMAIN}${videoId}?controls=1&autoplay=1&responsive=1`;

  return (
    <>
      <Box
        component="iframe"
        data-testid={`video-${testId}`}
        sx={videoStyles}
        src={src}
        title="Stop faxing and join the AllClear Health Network today"
        // @ts-ignore - iframe-specific props
        allow="autoplay; fullscreen"
        allowFullScreen
      />

      {isFirstPlay ? (
        <Box
          component="button"
          data-testid={`video-btn-play-${testId}`}
          aria-label="Start play"
          type="button"
          sx={{
            ...videoStyles,
            cursor: 'pointer',
            background: 'transparent',
          }}
          onClick={onPlayFist}
        />
      ) : null}
    </>
  );
}

export default VimeoVideoPlayer;
